

define(['squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index'], function (squid, template) {

    return squid.module('xo-member-sepa.directive', ['squid', 'xomodel.checkout', 'xomodel.fi']).directive('xoMemberSepa', function () {
        return {
            template: template,

            scope: {
                token: '=',
                parentCallbacks: '='
            },

            controller: function controller($scope, $CheckoutAppDataModel, $CheckoutSessionModel, $SepaModel, $populate, $rootScope) {

                $scope.sepa = $SepaModel.instance({ id: 123 });

                $scope.callbacks = {
                    sepaAccept: function sepaAccept() {

                        $populate($scope, {
                            checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                            checkoutSession: $CheckoutSessionModel.instance($scope.token)
                        }).then(function () {
                            $rootScope.$emit('loading');
                            $scope.sepa.action('sepaAccept', {
                                data: {
                                    bank: {
                                        id: $scope.sepa.bankId
                                    }
                                },
                                success: function success() {
                                    $scope.parentCallbacks.success($scope.sepa);
                                }
                            });
                        });
                    }

                };
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/member-sepa/directive.js
 ** module id = 424
 ** module chunks = 1
 **/